export const SESSION_KEYS = {
  auth: {
    nationalId: 'national_id',
    companyNationalId: 'company_national_id',
    firstName: 'first_name',
    lastName: 'last_name',
    mobileNumber: 'mobile_number',
    companyName: 'company_name',
    obfuscationMobileNumber: 'obfuscation_mobile_number',
    userType: 'user_type',
    accountsCount: 'accounts_count',
    otpTimeout: 'otp_timeout',
    referralCode: 'referral_code',
    utmSource: 'utm_source',
    utmCampaign: 'utm_campaign',
  },
  fundraiser: {
    auth: {
      companyNationalId: 'f_company_national_id',
      obfuscationMobileNumber: 'f_obfuscation_mobile_number',
      otpTimeout: 'f_otp_timeout',
      status: 'status',
    },
    register: {
      companyNationalId: 'f_company_national_id',
      companyName: 'f_company_name',
      firstName: 'f_first_name',
      lastName: 'f_last_name',
      jobTitle: 'f_job_title',
      nationalId: 'f_national_id',
      phoneNumber: 'f_phone_number',
      utm: 'utm',
      ceoName: 'f_ceo_name',
      ceoNationalId: 'f_ceo_national_id',
      ceoPhoneNumber: 'f_ceo_phone_number',
      sharedInfoAmount: 'f_shared_info_amount',
      sharedInfoFundUsage: 'f_shared_info_fund_usage',
    },
  },
}
